import { createSelector } from "reselect";
import { initialState } from "./reducer";

/**
 * Direct selector to the agendaDetail state domain
 */

const selectAgendaDetailDomain = state => state.agendaDetail || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectAgendaDetailDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectAgendaDetailDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectAgendaDetailDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectAgendaDetailDomain,
    substate => substate.firstRender,
  );

const makeSelectCourseDetail = () =>
  createSelector(
    selectAgendaDetailDomain,
    substate => substate.courseDetail,
  );
const makeSelectOnDateAbsences = () =>
  createSelector(
    selectAgendaDetailDomain,
    substate => substate.onDateAbsences,
  );
const makeSelectOnDateAttendances = () =>
  createSelector(
    selectAgendaDetailDomain,
    substate => substate.onDateAttendances,
  );

/**
 * Default selector used by Courses
 */

const makeSelectAgendaDetail = () =>
  createSelector(
    selectAgendaDetailDomain,
    substate => substate,
  );

export default makeSelectAgendaDetail;
export {
  selectAgendaDetailDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectCourseDetail,
  // on date
  makeSelectOnDateAbsences,
  makeSelectOnDateAttendances,
};
